var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    width: 28.8,
    height: 28.8,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 236.9a8.8 8.8 0 01-5.5-1.9 8.9 8.9 0 01-1.6-12.6l55.7-71.5-55.8-73.4a9 9 0 0114.4-10.9l64.2 84.4-64.3 82.4a8.9 8.9 0 01-7.1 3.5z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAwIDMwMCIgd2lkdGg9IjI4LjgiIGhlaWdodD0iMjguOCIgaWQ9Ikljb25fRnVuY3Rpb25fQ2hldnJvblJpZ2h0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xMjAgMjM2LjlhOC44IDguOCAwIDAxLTUuNS0xLjkgOC45IDguOSAwIDAxLTEuNi0xMi42bDU1LjctNzEuNS01NS44LTczLjRhOSA5IDAgMDExNC40LTEwLjlsNjQuMiA4NC40LTY0LjMgODIuNGE4LjkgOC45IDAgMDEtNy4xIDMuNXoiPjwvcGF0aD48L3N2Zz4=";
export { SvgIconChevronRight as ReactComponent };